import { STARTER } from 'self-service-api/constants/ProductLevels';
import { useAppSelector } from '../../../reducers';
import { hasProductsInProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { getIsTBSkuSelector, hasAnyTBSkuInProductDataSelector, productForSkuIdSelector, skuIdIsHubSelector, skuIdIsQuantityPackSelector } from '../../../selectors/ProductsSelectors';

/**
 * A portal is eligible for the Free to Starter touchless flow if:
 * - It's a free portal
 * - It's a seats/tb portal
 * - They're purchasing a single starter hub or TB suite sku
 * @param productConfigurations
 * @returns
 */
const useIsEligibleForFreeToStarterTouchlessFlow = productConfigurations => useAppSelector(state => {
  const isPaidPortal = hasProductsInProductInventorySelector(state);
  const isSeatsTBPortal = hasAnyTBSkuInProductDataSelector(state);
  if (isPaidPortal || !isSeatsTBPortal) {
    return false;
  }
  const productConfigs = productConfigurations.filter(config => !skuIdIsQuantityPackSelector(state, {
    skuId: config.skuId
  }) && (skuIdIsHubSelector(state, {
    skuId: config.skuId
  }) || getIsTBSkuSelector(state, {
    skuId: config.skuId
  })));
  if (productConfigs.length !== 1) {
    return false;
  }
  const productConfig = productConfigs[0];
  const product = productForSkuIdSelector(state, {
    skuId: productConfig.skuId
  });
  return product && product.productLevel === STARTER;
});
export default useIsEligibleForFreeToStarterTouchlessFlow;